import { render, staticRenderFns } from "./ApartmentItem.vue?vue&type=template&id=c7418848&scoped=true"
import script from "./ApartmentItem.vue?vue&type=script&lang=js"
export * from "./ApartmentItem.vue?vue&type=script&lang=js"
import style0 from "./ApartmentItem.vue?vue&type=style&index=0&id=c7418848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7418848",
  null
  
)

export default component.exports